import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Alert, Button, Card, Checkbox, Form, Input, Space, Typography, message } from "antd";
import { WarningOutlined } from "@ant-design/icons";
import { apiClient } from "../../../shared/api/AllApi";

const { Title, Paragraph } = Typography;

const CONFIRM_PHRASE = "RESET_ALL_DATA";

const Maintenance = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    if (values.confirm !== CONFIRM_PHRASE) {
      message.error(t("maintenanceConfirmMismatch"));
      return;
    }
    setLoading(true);
    try {
      await apiClient.post("/maintenance/reset-transactional", {
        confirm: CONFIRM_PHRASE,
        reset_purchasing: !!values.reset_purchasing,
      });
      message.success(t("maintenanceSuccess"));
      form.resetFields();
    } catch (e) {
      message.error(e?.response?.data?.message || t("maintenanceFailed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="list-page" style={{ maxWidth: 640 }}>
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        <Title level={3}>{t("maintenanceTitle")}</Title>
        <Alert
          type="error"
          showIcon
          icon={<WarningOutlined />}
          message={t("maintenanceWarningTitle")}
          description={t("maintenanceWarningBody")}
        />
        <Card>
          <Form form={form} layout="vertical" onFinish={onFinish} initialValues={{ reset_purchasing: false }}>
            <Paragraph type="secondary">{t("maintenanceBlurb")}</Paragraph>
            <Form.Item name="reset_purchasing" valuePropName="checked">
              <Checkbox>{t("maintenanceResetPurchasing")}</Checkbox>
            </Form.Item>
            <Form.Item
              name="confirm"
              label={t("maintenanceConfirmLabel", { phrase: CONFIRM_PHRASE })}
              rules={[{ required: true, message: t("maintenanceConfirmRequired") }]}
            >
              <Input autoComplete="off" placeholder={CONFIRM_PHRASE} />
            </Form.Item>
            <Form.Item>
              <Button type="primary" danger htmlType="submit" loading={loading} block>
                {t("maintenanceSubmit")}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Space>
    </div>
  );
};

export default Maintenance;
